import React from "react";

interface LoaderProps {
  loadingMessage?: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ loadingMessage, className = "bg-black bg-opacity-50 "}) => {
  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center ${className}`}>
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
        <div className="flex space-x-2 mb-4">
          <div
            className="w-2 h-2 bg-[#05acd9] rounded-full animate-bounce"
            style={{ animationDelay: "0ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-[#05acd9] rounded-full animate-bounce"
            style={{ animationDelay: "300ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-[#05acd9] rounded-full animate-bounce"
            style={{ animationDelay: "600ms" }}
          ></div>
        </div>
        <p className="text-gray-700 text-center">{loadingMessage}</p>
      </div>
    </div>
  );
};

export default Loader;
